// extracted by mini-css-extract-plugin
export default {"contactContent":"PDFFooter_contactContent__zjc3W","dividerLine":"PDFFooter_dividerLine__VRNTa","newThoughtworksLogo":"PDFFooter_newThoughtworksLogo__WH1jz"};